module.exports = function() {
  return new Worker("/" + "coffee-transpiler.a8f0201d.worker.js");
};